import React from 'react'

export default function ReminderBadge() {
  return (
    <span className="inline-flex items-center bg-accent text-white text-[11px] font-extrabold tracking-widest px-2 py-0.5">
      OVERDUE
    </span>
  )
}
